export enum OptInType {
  SERVICE = 'SERVICE',
  MARKETING = 'MARKETING',
  THIRD_PARTIES = 'THIRD_PARTIES',
}
